import React from "react";
import LegalLayout from "./LegalLayout";

const P = ({ children }) => <p>{children}</p>;

export default function Terms() {
  return (
    <LegalLayout
      eyebrow="Legal"
      title="Terms of Service"
      updated="February 2026"
      sections={[
        {
          id: "acceptance",
          title: "1. Acceptance of these terms",
          body: (
            <P>
              These terms govern your use of this website ("Site") operated by
              Prospera Financial Inc. ("<strong>Prospera</strong>"). By using
              the Site you accept these terms. If you do not agree, please do
              not use the Site.
            </P>
          ),
        },
        {
          id: "not-advice",
          title: "2. Nothing here is personal advice",
          body: (
            <P>
              Content on this Site, including articles, calculators, and
              example scenarios, is for general information only and does
              not constitute financial, legal, tax or insurance advice.
              Personal advice can only be given after a proper client
              relationship has been established, a full Know-Your-Client
              assessment has been completed, and a written engagement letter
              has been signed.
            </P>
          ),
        },
        {
          id: "no-solicitation",
          title: "3. No solicitation outside licensed jurisdictions",
          body: (
            <P>
              Insurance business is transacted only in provinces where the
              advisor is licensed. Investment business is transacted only in
              jurisdictions where the applicable dealing representative and
              carrier are registered. Nothing on this Site should be
              interpreted as a solicitation to residents of any jurisdiction
              where such solicitation would be unlawful.
            </P>
          ),
        },
        {
          id: "no-guarantee",
          title: "4. No guarantee of results",
          body: (
            <P>
              Past investment performance does not guarantee future results.
              Insurance illustrations are based on carrier-supplied
              assumptions which may not be realized. All projections are
              subject to underwriting, product availability, applicable
              legislation, and market conditions at the time of transaction.
            </P>
          ),
        },
        {
          id: "third-parties",
          title: "5. Third-party content and links",
          body: (
            <P>
              The Site may include third-party links (regulators, carriers,
              media). Prospera does not endorse or assume responsibility for
              third-party content.
            </P>
          ),
        },
        {
          id: "ip",
          title: "6. Intellectual property",
          body: (
            <P>
              The Site's design, marks, imagery and written content are the
              intellectual property of Prospera Financial Inc. or its
              licensors. You may not reproduce, republish or use them
              commercially without written permission.
            </P>
          ),
        },
        {
          id: "liability",
          title: "7. Limitation of liability",
          body: (
            <P>
              To the fullest extent permitted by law, Prospera and its
              principals are not liable for any indirect, incidental or
              consequential damages arising from your use of, or reliance on,
              this Site. Nothing in these terms limits any statutory rights
              you have under Ontario or Canadian consumer-protection or
              regulatory law.
            </P>
          ),
        },
        {
          id: "governing-law",
          title: "8. Governing law",
          body: (
            <P>
              These terms are governed by the laws of the Province of Ontario
              and the federal laws of Canada applicable in Ontario. Disputes
              are subject to the exclusive jurisdiction of the courts of
              Ontario.
            </P>
          ),
        },
        {
          id: "changes",
          title: "9. Changes to these terms",
          body: (
            <P>
              We may amend these terms from time to time. Material changes
              will be flagged at the top of this page.
            </P>
          ),
        },
      ]}
    />
  );
}
